module.exports = __webpack_public_path__ + "static/img/zisha@2x.effbc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/zisha@2x.png
// module id = Uf1C
// module chunks = 2